import React, { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import FAB from './FAB';

const RouteFAB: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const { ariaLabel, onClick, icon } = useMemo(() => {
    const path = location.pathname;

    if (path.startsWith('/shopping-list')) {
      return {
        ariaLabel: 'Add shopping item',
        icon: '＋',
        onClick: () => navigate('/shopping-list#add'),
      };
    }
    if (path.startsWith('/chores')) {
      return {
        ariaLabel: 'Add chore',
        icon: '＋',
        onClick: () => navigate('/chores#add'),
      };
    }
    if (path.startsWith('/recipes')) {
      return {
        ariaLabel: 'Add recipe',
        icon: '＋',
        onClick: () => navigate('/recipes#add'),
      };
    }
    if (path.startsWith('/meal-plans')) {
      return {
        ariaLabel: 'Create meal plan',
        icon: '＋',
        onClick: () => navigate('/meal-plans#new'),
      };
    }
    return {
      ariaLabel: 'Quick action',
      icon: '＋',
      onClick: () => navigate('/meal-plans'),
    };
  }, [location.pathname, navigate]);

  return <FAB ariaLabel={ariaLabel} onClick={onClick} icon={icon} />;
};

export default RouteFAB;


